<template>
  <div
    :class="[
      config.styles && config.styles.active_color ? config.styles.active_color : '',
      config.styles && config.styles.font_family ? config.styles.font_family : '',
      'app',
    ]" 
    id="app">
    <router-view :key="keyPage" />
    <ClientEvents />
    <div v-if="preload" class="preload">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="64" height="64" viewBox="0 0 128 128" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g><circle cx="16" cy="64" r="16"/><circle cx="16" cy="64" r="16" fill="#555" transform="rotate(45 64 64)"/><circle cx="16" cy="64" r="16" fill="#949494" transform="rotate(90 64 64)"/><circle cx="16" cy="64" r="16" fill="#ccc" transform="rotate(135 64 64)"/><circle cx="16" cy="64" r="16" fill="#e1e1e1" transform="rotate(180 64 64)"/><circle cx="16" cy="64" r="16" fill="#e1e1e1" transform="rotate(225 64 64)"/><circle cx="16" cy="64" r="16" fill="#e1e1e1" transform="rotate(270 64 64)"/><circle cx="16" cy="64" r="16" fill="#e1e1e1" transform="rotate(315 64 64)"/><animateTransform attributeName="transform" type="rotate" values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64" calcMode="discrete" dur="720ms" repeatCount="indefinite"/></g></svg>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import cacheKeyPage from '@/mixins/cache-key-page.mixin';

export default {
  name: 'App',
  mixins: [cacheKeyPage],
  components: {
    ClientEvents: () => import('@/components/client-events'),
  },
  
  computed: {
    ...mapState({
      basketOrder: state => state.basket.basketOrder,
      config: state => state.user.config,
      preload: state => state.common.preload,
      userInfo: state => state.user.userInfo,
    }),
  },
  methods: {
    ...mapActions('user', [
      'checkLogin',
      'setConfig',
    ]),

    ...mapActions('basket', [
      'setBasketOrder',
    ]),

    ...mapMutations('account', [
      'setNeedOpenModal',
    ]),

    ...mapMutations('common', [
      'updateCountry',
    ]),
  },

  created() {
    this.checkLogin();
    if (this.$route.query.hide !== undefined) {
      this.setConfig({
        'hide': true,
      });
    } else {
      this.setConfig({
        'hide': false
      });
    }
    let loc = (window.location != window.parent.location) ? document.referrer : document.location.href;
    if (loc.match('.by')) {
      this.updateCountry(true);
    }
  },

  watch: {
    $route(to, from) {
      if (from.name === 'edit-order') {
        this.setBasketOrder({
          'id': from.params.uuid,
        }).then(res => {
          this.setNeedOpenModal(this.basketOrder.id)
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.app {
  height: 100%;
  font-family: var(--main-font);
}

.preload {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}
</style>
